import styled from "styled-components";

export const CreateStandaloneTruckModalStyle = styled.div`
    .ant-input-number {
        width: 100%;
    }
`;
